import simpleLightbox from 'simplelightbox';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class GalleryBlock {
    constructor(el) {
        if (!this.set(el)) return;

        if (
            document.readyState === 'complete' ||
            (document.readyState !== 'loading' &&
                !document.documentElement.doScroll)
        ) {
            this.init();
        } else {
            document.addEventListener('DOMContentLoaded', this.init.bind(this));
        }
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.slider = this.root.querySelector('[data-gallery-block-swiper]');
        this.pagination = this.root.querySelector(
            '[data-gallery-block-pagination]'
        );
        this.prev = this.root.querySelector('[data-gallery-block-prev]');
        this.next = this.root.querySelector('[data-gallery-block-next]');
        this.count = this.root.querySelector('[data-gallery-block-count]');

        this.swiper = null;
        this.galleries = null;
        this.galleryInstance = null;

        return true;
    }

    init() {
        this.initSwiper();
    }

    initSwiper() {
        if (!this.slider) return;

        this.swiper = new Swiper(this.slider, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 16,
            breakpoints: {
                // Mobile
                480: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                },
                // Tablet
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                // Desktop
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
            },
            navigation: {
                prevEl: this.prev,
                nextEl: this.next,
            },
            on: {
                init: function () {
                    this.setLightbox();
                }.bind(this),
            },
        });
    }

    setLightbox() {
        this.galleries = this.root.querySelectorAll(
            '.gallery-block__swiperItem a'
        );

        console.log(this.galleries);

        if (this.galleryInstance !== null) this.galleryInstance.destroy();
        if (this.galleries && this.galleries.length > 0) {
            this.galleryInstance = new simpleLightbox(this.galleries, {
                closeText: '',
            });

            console.log(this.galleryInstance);
        }
    }
}

const initGalleriesBlocks = () => {
    const sections = document.querySelectorAll('[data-gallery-block]');
    if (sections) sections.forEach(item => new GalleryBlock(item));
};

initGalleriesBlocks();
